<template>
    <span>
        <a
            v-cloak
            v-if="isFavorite !== null"
            href="#"
            @click.prevent="favorite"
            class="button"
            :class="{ simple: !isFavorite }"
        >
            <i class="fa" :class="isFavorite ? 'fa-star' : 'fa-star-o'"></i>
            {{ isFavorite ? 'Remove from favorites' : 'Add to favorites' }}
        </a>
    </span>
</template>
<script>
import axios from 'axios';

export default {
    data: () => ({
        isFavorite: null,
    }),
    mounted() {
        axios.get(`/favorite/${this.id}`).then(({ data }) => this.isFavorite = data)
    },
    props: {
        id: { required: true },
    },
    methods: {
        favorite() {
            if (this.isFavorite) {
                this.removeFavorite()
            } else {
                this.createFavorite()
            }
        },
        createFavorite() {
            axios.post(`/favorite/${this.id}`).then(r => {
                this.isFavorite = true
            })
        },
        removeFavorite() {
            axios.delete(`/favorite/${this.id}`).then(r => {
                this.isFavorite = false
            })
        },
    },
}
</script>
